import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'

function getUser() {
    return Auth.currentAuthenticatedUser().then((user) => {
        if (user && user.signInUserSession) {
            return user
        } else {
            return null
        }
    }).catch((err) => {
        throw err
    });
}

async function signIn(username, password, store) {
    try {
        const user = await Auth.signIn(username, password);
        if (user) {
            AmplifyEventBus.$emit('authState', 'signedIn');
        } else {
            store.dispatch("setGlobalError",{value:"User does not exist"})
        }
    } catch (err) {
        store.dispatch("setGlobalError",{value:err.message})
        if (err.code === 'UserNotConfirmedException') {
            // The error happens if the user didn't finish the confirmation step when signing up
            // In this case you need to resend the code and confirm the user
            // About how to resend the code and confirm the user, please check the signUp part
        } else if (err.code === 'PasswordResetRequiredException') {
            // The error happens when the password is reset in the Cognito console
            // In this case you need to call forgotPassword to reset the password
            // Please check the Forgot Password part.
        } else if (err.code === 'NotAuthorizedException') {
            // The error happens when the incorrect password is provided
        } else if (err.code === 'UserNotFoundException') {
            // The error happens when the supplied username/email does not exist in the Cognito user pool
        }
    }
}

function signOut() {
    return Auth.signOut()
        .then(data => {
            AmplifyEventBus.$emit('authState', 'signedOut');
            return data;
        })
        .catch(err => {
            return err;
        });
}

export { getUser, signIn, signOut };
